<template lang="pug">
  ._layout
    OfflineCompanion
    //- .resetCoaching(v-if="isDev" @click="resetCoaching")
    //-   i.material-icons delete
    TheHeader
    ._layout-content
      template(v-if="loading")
        div Carregando...
      GlobalWrapper(v-else)
        nuxt
    TheBottomTabBar
</template>

<script>
import TheHeader from '~/components/TheHeader'
import TheBottomTabBar from '~/components/TheBottomTabBar'
import OfflineCompanion from '~/components/OfflineCompanion'
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  middleware: ['Authenticated', 'IsOffline', 'IsLocked'],
  components: {
    TheHeader,
    TheBottomTabBar,
    OfflineCompanion,
    GlobalWrapper,
  },
  computed: {
    isDev() {
      return this.$root.context.isDev
    },
    loading() {
      return (
        !this.$store.state.coaching.current &&
        this.$route.path.match(/\/coaching\/(?:(?!coachee)).{1,}/)
      )
    },
  },
  methods: {
    resetCoaching() {
      this.$store.commit('coaching/UPDATE_ROOT', {
        current: null,
        offlineSync: {},
        lastCoaching: null,
      })
      this.$store.commit('coaching/UPDATE_CURRENT', null)
      this.$router.push('/coaching')
    },
  },
}
</script>

<style lang="sass">
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --textColor: #767676
  --textHighlightColor: #232323
  --backgroundSteak: #ffaaa5
  --greenColor: #00e686
  --darkBlueColor: #1A4982
  background-color: var(--bgColor)
  color: var(--textColor)
  font:
    family: 'Montserrat', sans-serif
    size: 16px
._layout
  min-height: 100vh
  display: flex
  flex-direction: column
  &-content
    flex: 1
    padding-bottom: 60px
    position: relative
.resetCoaching
  --size: 32px
  position: fixed
  top: 16px
  left: calc(50vw - var(--size)/2)
  display: flex
  align-items: center
  justify-content: center
  z-index: 99999
  color: white
  background: red
  border-radius: 50%
  width: var(--size)
  height: var(--size)
</style>
